import { render, staticRenderFns } from "./AddEventPage.vue?vue&type=template&id=49bd71d6&scoped=true&lang=pug"
import script from "./AddEventPage.vue?vue&type=script&lang=js"
export * from "./AddEventPage.vue?vue&type=script&lang=js"
import style0 from "./AddEventPage.vue?vue&type=style&index=0&id=49bd71d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bd71d6",
  null
  
)

export default component.exports